import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M28 12h-1.02A10.68 10.68 0 0024 8.26V3.5a.5.5 0 00-.49-.5h-.01c-1.86.03-5.75.27-7.55 2.79a.49.49 0 01-.4.21h-.71a10.9 10.9 0 00-10.19 6.95A.9.9 0 014 12v-.01A1 1 0 102 12a2.95 2.95 0 002.14 2.89A9.96 9.96 0 004 16.46a10.5 10.5 0 004 8.28V28a1 1 0 001 1h4a1 1 0 001-1v-.5a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v.5a1 1 0 001 1h4a1 1 0 001-1v-2.57a9.99 9.99 0 001.56-1.17 1.02 1.02 0 01.67-.26H28a2 2 0 002-2v-8a2 2 0 00-2-2zm0 10h-2.77a3 3 0 00-2.01.78 8.84 8.84 0 01-1.27.95l-.95.59V27h-2.05a2.5 2.5 0 00-2.45-2h-2a2.5 2.5 0 00-2.45 2H10v-3.23l-.76-.6A8.46 8.46 0 016 16.47 8.7 8.7 0 0114.84 8h.71a2.5 2.5 0 002.03-1.05c.52-.74 1.71-1.6 4.42-1.87v4.15l.76.6a8.58 8.58 0 012.41 3.03l.54 1.14H28z"/><circle cx="22" cy="15" r="1"/><path d="M16 11h-3a2.92 2.92 0 00-3 2.83V14a1 1 0 002 0 .91.91 0 01.82-1 .9.9 0 01.18 0h3a1 1 0 000-2z"/>';
export var PigOutlineSVG = function PigOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
PigOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PigOutlineSVG);